export default __webpack_public_path__ + "static/media/itchbook-pink-14px.97cd7eca.svg";